import { contrastRatio } from '@yola/yola-palette-generator';
import utils from '../../common/utils';

const { reduceColorPointByRatio, increaseColorPointByRatio } = utils;
const firstCondition = (ratio) => ratio >= 3;
const secondCondition = (ratio) => ratio < 12;

const dark = (params) => {
  const { targetColor, backgroundColor, targetColorPalette } = params;
  const fallback = {
    rule: 'priceText.dark',
    params,
  };

  let calculatedColor = reduceColorPointByRatio({
    targetColor,
    backgroundColor,
    targetColorPalette,
    condition: firstCondition,
    fallback,
  });

  if (secondCondition(contrastRatio(backgroundColor, calculatedColor))) {
    return calculatedColor;
  }

  calculatedColor = increaseColorPointByRatio({
    targetColor: calculatedColor,
    backgroundColor,
    targetColorPalette,
    condition: secondCondition,
    fallback,
  });

  return calculatedColor;
};

export default dark;
